module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "title"
  }, [_c('span', {
    staticClass: "green1"
  }, [_vm._v("COMFORT CROCHETED")])]), _vm._v(" "), _c('p', {
    staticClass: "title1"
  }, [_c('span', {
    staticClass: "litgreen"
  }, [_vm._v("AFGHANS")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "orange3"
  }, [_vm._v("A"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("N")]), _vm._v(" H"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EIRLOOM")]), _vm._v(" T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("RIO FOR A")]), _vm._v(" C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OZY")]), _vm._v(" H"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OME AND")]), _vm._v(" F"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AMILY")])])]), _vm._v(" "), _c('p', {
    staticClass: "centert1a"
  }, [_c('span', {
    staticClass: "orange3"
  }, [_vm._v("Norah Gaughan, Margery Winter, and the Berroco Design Team")])]), _vm._v(" "), _c('p', {
    staticClass: "centert"
  }, [_c('span', {
    staticClass: "orange3"
  }, [_vm._v("Photographs by Thayer Allyson Gowdy"), _c('br'), _vm._v("Styling by Karen Schaupeter")])]), _vm._v(" "), _c('p', {
    staticClass: "centert1s"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("STC CRAFT / A MELANIE FALICK BOOK"), _c('br'), _vm._v("STEWART, TABORI & CHANGE"), _c('br'), _vm._v("NEW YORK")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bd608206","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/2_Title.vue
// module id = 60
// module chunks = 0